import { JobsService } from 'app/API';
import type { TUploaderAdapter } from '@components/Files/UploadProvider/types/TUploadParams';
import type { TCall } from 'app/queries/types/TCall';

export const AttachmentUploader = (call: TCall, getJobId: () => string, organizationId: string): TUploaderAdapter => ({
  requestParams: async ({ file, meta }) => {
    void file;
    const jobId = getJobId();
    const { url } = await call(() =>
      JobsService.getJobAttachmentUploadLink({
        jobId,
        file: meta.name,
        oid: organizationId,
      }),
    );
    return { url, method: 'PUT' };
  },
  performUpload: async ({ file, params, onProgress, signal }) => {
    if (!(file instanceof File)) {
      throw new Error('Only File supported');
    }
    return new Promise<{ serverId?: string }>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', params.url);
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable && onProgress) {
          onProgress((e.loaded / e.total) * 100);
        }
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({});
          return;
        }
        reject(new Error(`Attachment upload failed ${xhr.status}`));
      };
      xhr.onerror = () => reject(new Error('Network error during attachment upload'));
      if (signal) {
        signal.addEventListener('abort', () => xhr.abort());
      }
      xhr.send(file);
    });
  },
});
